<template>
  <div class="phoneTable">
    <div class="btnStore">
      <div class="flex" style="margin-right: 10px">
        <span style="min-width: max-content;">门店商家：</span>
        <el-select v-model="seachCompanyId" filterable clearable @change="companyChange" placeholder="请选择"
          class="el-form-group_isRound">
          <el-option v-for="item in companySelectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="flex" style="margin-right: 10px">
        <el-dropdown @command="postCommand" >
          <span class="el-dropdown-link">
            {{ chosePostCommand ? chosePostCommand : '选择岗位' }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) of roleList" :key="index" :command="item.id">{{ item.roleName
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-select class="el-form-group_isRound" :disabled="!chosePostCommand" clearable @change="marketerIdChange()" v-model="postSelect" placeholder="请选择">

          <el-option v-for="(item,inx) of postOptions"  :key="inx" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="time-select">
        <div class="btn" :class="dateType == '01' ? 'btnType2' : 'btnType-after2'" @click="dataObtain('01')">
          今日
        </div>
        <div class="btn" :class="dateType == '03' ? 'btnType2' : 'btnType-after2'" @click="dataObtain('03')">
          本周
        </div>
        <div class="btn" :class="dateType == '05' ? 'btnType2' : 'btnType-after2'" @click="dataObtain('05')">
          本月
        </div>
      </div>
      <div>
        <el-date-picker v-model="valueTime" type="daterange" range-separator="至" value-format="timestamp"
          start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
      </div>
      <div style="margin-left: 10px">
        <el-button type="primary" @click="seachStore" round>查询</el-button>
      </div>
      <div style="margin-left: 10px">
        <el-button icon="el-icon-download" type="success" round @click="exportExcelStoreFn">导出Excel</el-button>
      </div>
    </div>
    <div  class="el-table-container" :style="tableData.length > 10 ? 'height: 500px;overflow-y: scroll;' : ''">
        <el-table ref="tableList" :data="tableData" :default-sort="{ prop: 'allDealCount', order: 'descending' }"
        @sort-change="sortTable" v-loading="phoneTableLoading" border style="width: 100%" stripe>
            <el-table-column prop="rownum" label="序号" width="70" align="center">
                <template slot-scope="{ row }">
                <div class="numBG_1" v-if="row.rownum === 1">1</div>
                <div class="numBG_2" v-else-if="row.rownum === 2">2</div>
                <div class="numBG_3" v-else-if="row.rownum === 3">3</div>
                <div v-else>{{ row.rownum }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="cmccCompanyName" label="门店商户" width="150" align="center">
                <template slot-scope="{ row }">
                    <span>{{row.cmccCompanyName}}</span>
                </template>
            </el-table-column>
            <el-table-column :label=" item.headTitle"  align="center" v-for="(item,index) in headerList" :key="item.value">
            <el-table-column :prop="index==0?'allInquiryCount':(index==1?'cmccInquiryCount':'kaInquiryCount')" label="询价量" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" width="90px">
                <template slot-scope="{ row }">
                <span v-if="index==0">{{ row.allInquiryCount}}</span>
                <span v-if="index==1">{{ row.cmccInquiryCount}}</span>
                <span v-if="index==2" style="color: #0981ff;cursor: pointer;text-decoration: underline;" @click="kaInquiryCount(row)">{{ row.kaInquiryCount}}</span>
                </template>
            </el-table-column>
            <el-table-column :prop="index==0?'allDealCount':(index==1?'cmccDealCount':'kaDealCount')" label="成交量" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" width="90px">
                <template slot-scope="{ row }">
                <span v-if="index==0">{{ row.allDealCount}}</span>
                <span v-if="index==1">{{ row.cmccDealCount}}</span>
                <span v-if="index==2">{{ row.kaDealCount}}</span>
                </template>
            </el-table-column>    
            <el-table-column :prop="index==0?'allDealRatio':(index==1?'cmccDealRatio':'kaDealRatio')" label="成交率" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" width="90px">
                <template slot-scope="{ row }">
                <span v-if="index==0">{{ row.allDealRatio}}%</span>
                <span v-if="index==1">{{ row.cmccDealRatio}}%</span>
                <span v-if="index==2">{{ row.kaDealRatio}}%</span>
                </template>
            </el-table-column>
            <el-table-column :prop="index==0?'allDealPrice':(index==1?'cmccDealPrice':'kaDealPrice')" label="成交金额" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" width="100px">
                <template slot-scope="{ row }">
                <span v-if="index==0">{{ row.allDealPrice}}元</span>
                <span v-if="index==1">{{ row.cmccDealPrice}}元</span>
                <span v-if="index==2">{{ row.kaDealPrice}}元</span>
                </template>
            </el-table-column>
            <el-table-column :prop="index==0?'allAvgDealPrice':(index==1?'cmccAvgDealPrice':'kaAvgDealPrice')" label="成交单价" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" width="100px">
                <template slot-scope="{ row }">
                <span v-if="index==0">{{ row.allAvgDealPrice}}元</span>
                <span v-if="index==1">{{ row.cmccAvgDealPrice}}元</span>
                <span v-if="index==2">{{ row.kaAvgDealPrice}}元</span>
                </template>
            </el-table-column>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog title='操作提示' :visible.sync="commandShow" :close-on-click-modal="false" width="550px"
      @closed="commandClosed">
      <div class="command">
        <div style="width: 88px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commandShow = false">取消</el-button>
        <el-button type="primary" :loading="commandBtnLoading" @click.native="commandSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="cmccCompanyName" :visible.sync="personsVisible" :close-on-click-modal="false" width="900px" v-if="personsVisible" @close="personsVisibleclose">
      <div>
        <el-table :data="personData" style="width: 100%" v-loading="loading2" border stripe :default-sort="{ prop: 'kaInquiryCount', order: 'descending' }"
        @sort-change="kasortTable">
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="kaCompanyName" label="商户名称" align="center">
          </el-table-column>
          <el-table-column prop="kaInquiryCount" label="询价量" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          </el-table-column>
          <el-table-column prop="kaDealCount" label="成交量" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          </el-table-column>
          <el-table-column prop="kaDealRatio" label="成交率" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span >{{ scope.row.kaDealRatio }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="kaDealPrice" label="成交金额" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span >{{ scope.row.kaDealPrice }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="kaAvgDealPrice" label="成交单价" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
            <template slot-scope="scope">
              <span >{{ scope.row.kaAvgDealPrice }}元</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="orderPagina">
            <el-pagination float="right" background :current-page="this.kapage.pageNum" :page-size="this.kapage.pageSize"
        layout="total, prev, pager, next,jumper" :total="this.kapage.total" class="el-pagination-c"
        @current-change="kahandleCurrentChange" />
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "phoneTable",
  props: ['companySelectList'],
  data() {
    return {
      roleList: [],
      chosePostCommand: null,
      postOptions:[],
      postSelect: null,
      tableData: [],
      phoneTableLoading: false,
      commandBtnLoading: false,
      commandShow: false,
      page: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      valueTime: "",
      startTime: "",
      endTime: "",
      dateType: "01",
      seachCompanyId: "",
      command: "",
      orderTypeTable: "04",
      ackOrDesc: '01', // 降序：01，升序：02
      columnType: '02', 
      paramsData: {},
      headerList:[{headTitle:"总数据",value:0},{headTitle:"省移动数据",value:1},{headTitle:"KA数据",value:2}],
      cmccCompanyId:"",
      cmccCompanyName:"",
      personsVisible:false,
      loading2:false,
      kaackOrDesc: '01', // 降序：01，升序：02
      kacolumnType: '01', 
      kapage: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      personData:[]
    };
  },
  created() {
    this.handleCurrentChange();
    _api.marketerRoleList({marketerTerminalCode:"Store_Market"}).then(res => {
      this.roleList = res.data
      console.log('roleList', this.roleList);

    })
  },
  methods: {
    postCommand(command) {

      this.chosePostCommand = this.roleList.find(item => item.id === command).roleName
      _api.marketerUserSelectList({
        roleId:command
      }).then(res => {
        this.postSelect = null
this.postOptions = res.data 
    })
    },
    marketerIdChange() {

this.handleCurrentChange()

},
    // 列表排序
    sortTable(column) {
      console.log('===', column);
    console.log('column.prop', column.prop);
      if (column.prop) {
        // 排序方式
        if (column.order == 'ascending') {
          this.ackOrDesc = '02'
        } else if (column.order == 'descending') {
          this.ackOrDesc = '01'
        }

        // 排序字段
        switch (column.prop) {
          case 'allInquiryCount':
            this.columnType = '01';
            break;
          case 'cmccInquiryCount':
            this.columnType = '06';
            break;
          case 'kaInquiryCount':
            this.columnType = '11';
            break;
          case 'allDealCount':
            this.columnType = '02';
            break;
          case 'cmccDealCount':
            this.columnType = '07';
            break;
          case 'kaDealCount':
            this.columnType = '12';
            break;
          case 'allDealRatio':
            this.columnType = '03';
            break;
          case 'cmccDealRatio':
            this.columnType = '08';
            break;
          case 'kaDealRatio':
            this.columnType = '13';
            break;
          case 'allDealPrice':
            this.columnType = '04';
            break;
          case 'cmccDealPrice':
            this.columnType = '09';
            break;
          case 'kaDealPrice':
            this.columnType = '14';
            break;
          case 'allAvgDealPrice':
            this.columnType = '05';
            break;
          case 'cmccAvgDealPrice':
            this.columnType = '10';
            break;
          case 'kaAvgDealPrice':
            this.columnType = '15';
            break;
          default:
            this.columnType = '02';
        }

        this.orderTypeTable = '00'
      }
      this.handleCurrentChange()

    },
    kasortTable(column){
   console.log('===', column);
    console.log('column.prop', column.prop);
      if (column.prop) {
        // 排序方式
        if (column.order == 'ascending') {
          this.kaackOrDesc = '02'
        } else if (column.order == 'descending') {
          this.kaackOrDesc = '01'
        }

        // 排序字段
        switch (column.prop) {
          case 'kaInquiryCount':
            this.kacolumnType= '01';
            break;
          case 'kaDealCount':
            this.kacolumnType = '02';
            break;
          case 'kaDealRatio':
           this.kacolumnType = '03';
            break;
          case 'kaDealPrice':
          this.kacolumnType = '04';
            break;
          case 'kaAvgDealPrice':
            this.kacolumnType = '05';
            break;
          default:
            this.columnType = '01';
        }
      }
      this.kahandleCurrentChange()
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val);
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const baseRequest = {
        ackOrDesc: this.ackOrDesc,
        orderType: this.columnType,
        // command: "",
        dateType: this.dateType,
        endTime: this.endTime,
        companyId: this.seachCompanyId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        startTime: this.startTime,
        marketerId:this.postSelect
      };
      this.phoneTableLoading = true
      this.paramsData = baseRequest
      const loading = this.$loading({
        lock: true,
        text: '正在加载数据中，请耐心等待！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      _api.platformOrderCmccCompanyRankList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data||[];
        }
        loading.close();
        this.phoneTableLoading = false
      }).catch(ree => {
        loading.close();
      });
    },
    //时间选择点击事件
    dataObtain(way) {
      this.dateType = way;
      this.valueTime = "";
      this.startTime = "";
      this.endTime = "";
      this.handleCurrentChange();
    },
    seachStore() {
      if (this.valueTime !== null && this.valueTime) {
        (this.dateType = ""),
          (this.startTime = this.valueTime[0]),
          (this.endTime = this.valueTime[1]);
      } else {
        if (!this.dateType) {
          (this.dateType = "01"), (this.startTime = ""), (this.endTime = "");
        }
      }
      this.handleCurrentChange();
    },
    // 商家查询
    companyChange(e) {
      this.$refs.tableList.clearSort()
      this.ackOrDesc = '01'
      this.columnType = this.orderTypeTable
      this.seachStore()
    },
    exportExcelStoreFn() {
      this.commandShow = true
    },
    commandClosed() {
      this.commandShow = false
      this.command = ""
    },
    commandSubmit() {
      if (!this.command) {
        this.$message.error('请输入动态口令')
        return
      }
      this.exportExcelStore()
    },
    exportExcelStore() {
      let data = {
        ...this.paramsData,
        command:this.command
      }
      this.commandBtnLoading = true
      _api.platformOrderCmccCompanyRankListExcel(data).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "导出失败");
              this.commandBtnLoading = false
            }
          } catch (err) {
            let start = "";
            let end = ""
            if (data.startTime || data.endTime) {
              start = moment(Number(data.startTime)).format("YYYY.MM.DD")
              end = moment(Number(data.endTime)).format("YYYY.MM.DD")
            } else if (data.dateType == '01') {
              start = moment().month("YYYY-MM-DD").format('YYYY.MM.DD')
            } else if (data.dateType == '03') {
              start = moment().weekday(1).format('YYYY.MM.DD')
              end = moment().month("YYYY-MM-DD").format('YYYY.MM.DD')
            } else if (data.dateType == '05') {
              start = moment().startOf('month').format('YYYY.MM.DD')
              end = moment().month("YYYY-MM-DD").format('YYYY.MM.DD')
            }
            console.log(moment().startOf('month'));
            const fileName = `【省移动商户-交易排行】${start || ''}${end ? '-' + end : ''}.xlsx`;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.commandBtnLoading = false
            this.commandShow = false
          }
        });
        reader.readAsText(blob, "utf-8");
      });
    },
    //查询ka详情
    kaInquiryCount(row){
      this.cmccCompanyId=row.cmccCompanyId
      this.cmccCompanyName=`繁星KA数据-${row.cmccCompanyName}`
      this.personsVisible=true
      this.loading2=true
      this.kahandleCurrentChange(1)
    },
    personsVisibleclose(){
      this.personsVisible=false
      this.cmccCompanyId=''
      this.cmccCompanyName=''
    },
    kahandleCurrentChange(val){
    if (val) {
        this.kapage.pageNum = val;
      } else {
        this.kapage.pageNum = 1;
      }
      _api.platformOrderCmccCompanyRankDownKa({ackOrDesc:this.kaackOrDesc,cmccCompanyId:this.cmccCompanyId,orderType: this.kacolumnType,dateType: this.dateType,endTime: this.endTime,pageNum: this.kapage.pageNum,pageSize: this.kapage.pageSize,startTime: this.startTime,}).then(res=>{
          this.loading2=false
        this.personData=res.data.records
          this.kapage.pageNum = res.data.current;
          this.kapage.total = res.data.total;
      }).catch(err=>{
        this.loading2=false
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.fc_line {
  color: #0981FF;
  text-decoration: underline;
  cursor: pointer;
}

.f-line {
  text-decoration: underline;
}

.phoneTable {
  padding: 0 20px 20px;

  .img-el-heard {
    display: flex;
    justify-content: center;

    img {
      margin: 0px 0 -3px 3px;
    }
  }

  .orderPagina {
    padding: 30px 0px 30px 0;
    display: flex;
    justify-content: flex-end;
  }

  .numBG_1 {
    background-image: url("../../../../assets/images/imgAll/icon_01.png");
    background-size: 100%;
    color: white;
  }

  .numBG_2 {
    background-image: url("../../../../assets/images/imgAll/icon_02.png");
    background-size: 100%;
    color: white;
  }

  .numBG_3 {
    background-image: url("../../../../assets/images/imgAll/icon_03.png");
    background-size: 100%;
    color: white;
  }

  .tableBtn {
    color: #0981ff;
    cursor: pointer;
  }

  .store-dialog {
    /deep/.el-dialog__body {
      padding: 21px 20px 20px 20px;
    }
  }

  .btnStore {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    margin: 22px 0;

    .time-select {
      display: flex;

      .btn {
        box-shadow: 2px 1px 10px 0px rgba(63, 44, 245, 0.2);
        margin: 0px 10px 0px 0;
        text-align: center;
        cursor: pointer;
      }

      .btnType-after2 {
        // width: 33%;
        width: 80px;
        min-width: max-content;
        height: 40px;
        background: #ffffff;
        color: #0981ff;
        line-height: 40px;
        border-radius: 20px;
      }

      .btnType2 {
        width: 80px;
        min-width: max-content;
        height: 40px;
        background: #0981ff;
        color: white;
        line-height: 40px;
        border-radius: 20px;
      }
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex-jb {
    justify-content: space-between;
  }

  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
}
  /deep/.el-table--border th.is-center {
    border-bottom: 1px solid #c4d7fd !important;
  }
</style>
